// CSS
import "normalize.css/normalize.css";
import '../css/styles.scss';

// JavaScript
window.moment = require("moment");
require("./index.js");
